import React from "react";
import { Provider } from "react-redux";
import App from "./App";
import { ThemeProvider } from "./context/ThemeContext";
import { HomepageRenderProvider } from "./context/HomepageRenderContext";

export default function PortalRoot({ store, bootstrap }) {
  return (
    <React.StrictMode>
      <HomepageRenderProvider bootstrap={bootstrap}>
        <Provider store={store}>
          <ThemeProvider><App initialPath={bootstrap?.pathname} /></ThemeProvider>
        </Provider>
      </HomepageRenderProvider>
    </React.StrictMode>
  );
}
